import { createContext, useContext, useState, ReactNode } from "react";

type LandingRole = "dispatcher" | "carrier";

interface RoleSectionsContextType {
  role: LandingRole;
  setRole: (role: LandingRole) => void;
}

const RoleSectionsContext = createContext<RoleSectionsContextType>({
  role: "dispatcher",
  setRole: () => {},
});

export function RoleSectionsProvider({ children }: { children: ReactNode }) {
  const [role, setRole] = useState<LandingRole>("dispatcher");
  return (
    <RoleSectionsContext.Provider value={{ role, setRole }}>
      {children}
    </RoleSectionsContext.Provider>
  );
}

export function useLandingRole() {
  return useContext(RoleSectionsContext);
}

export type { LandingRole };
